"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('toggleMessageOptionCheckbox')(function toggleMessageOptionCheckbox(field, checked, state) {
    var optionState = state.optionState;
    optionState[field] = checked;
}));
//# sourceMappingURL=toggleMessageOptionCheckbox.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-option/lib/actions/toggleMessageOptionCheckbox.js
// module id = 5056
// module chunks = 2